import { Link } from 'react-router';
import { phrase } from '../lib/i18n/runtime';

export function AccessDenied({ message }: { message?: string }) {
  return (
    <section className="stack" aria-labelledby="access-denied-heading">
      <h1 id="access-denied-heading">{phrase('You don’t have access')}</h1>
      <p>
        {message ??
          phrase(
            'Your role in this workspace does not include this area. Ask a workspace owner if you need access.',
          )}
      </p>
      <Link to="/">{phrase('Go to your home page')}</Link>
    </section>
  );
}
